import React from "react";
import { Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import "./styles/Global.css";
import Course from "./pages/Course";
import WritingCourse from "./pages/WritingCourse";
import About from "./pages/About";
import Terms from "./pages/Terms";
import ContactUs from "./pages/ContactUs";

const AppRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/home" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/courses" element={<Course />} />
      <Route path="/Creative-Writing-Course" element={<WritingCourse />} />
      <Route path="/termscondition" element={<Terms />} />
      <Route path="/ContactUs" element={<ContactUs />} />
    </Routes>
  );
};

export default AppRoutes;
